import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'

import TableActionsBlock from 'src/utils/components/CustomTable/components/TableActionsBlock/TableActionsBlock'
import TableSortIcon from '../../../../components/customElements/TableSortIcon/TableSortIcon'
import { isAdministration } from '../../../../services/AccountService'
import TableScrollButtons from '../../../../utils/components/CustomTable/components/TableScrollButtons/TableScrollButtons'
import { debounce } from '../../../../utils/debounce/debounce'
import NoDataFound from './components/NoDataFound'
import {
  getTableRowTypographySx,
  tableContainerSx,
  tableRowBoxSx,
} from './consts/styles.const'
import store from './RequestsNotesTableOptimizedStore'
import TableOptimizedRow from './TableOptimizedRow'
import { getCellSx } from './utils/getCellSx'
import { getColumns } from './utils/getColumns'

const RequestsNotesTableOptimized = ({
  operatorsStore,
  onRowClick,
  showPagination = true,
  withScrollButtons,
}) => {
  const { data, addServiceProps, getIdSelectedOrders, isSomeChecked } = store
  const [inputValue, setInputValue] = useState(operatorsStore.page + 1)
  const { collection } = operatorsStore
  const [newRowsFront, setNewRowsFront] = useState([])

  const columns = getColumns(isAdministration())

  useEffect(() => {
    addServiceProps(collection)
    getIdSelectedOrders()
  }, [collection])

  const onPageChange = useCallback(
    (event, page) => {
      if (page >= 0) {
        operatorsStore.loadPageAction(page)
      }
    },
    [operatorsStore]
  )

  const onPageSizeChange = useCallback(
    (event) => {
      operatorsStore.pageSize = event.target.value
      onPageChange(0, 0)
    },
    [onPageChange, operatorsStore]
  )

  const handleSort = (column) => {
    if (column.handleClick) {
      operatorsStore.reversPage(column.handleClick)
    }
  }

  return (
    <TableContainer
      sx={tableContainerSx}
      component={Paper}
      id='custom-table-container'
    >
      <TableActionsBlock
        rows={data}
        showPagination={showPagination}
        total={operatorsStore.total}
        setInputValue={setInputValue}
        pageSize={operatorsStore.pageSize}
        inputValue={inputValue}
        page={operatorsStore.pageNumber}
        rowsPerPageOptions={[50, 100, 200, 300, 500]}
        onPageSizeChange={onPageSizeChange}
        onPageChange={debounce(null, onPageChange, 300)}
        doublePagination={true}
        setNewRowsFront={setNewRowsFront}
      >
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              {columns.map((column) => {
                return (
                  <TableCell
                    key={column.propName}
                    onClick={() => handleSort(column)}
                    sx={getCellSx(column)}
                  >
                    <Box sx={tableRowBoxSx(column)}>
                      <Typography sx={getTableRowTypographySx(column)}>
                        {column.label}
                      </Typography>
                      {column.sort && (
                        <TableSortIcon
                          isReverse={operatorsStore.checkIsRevers(column.sort)}
                        />
                      )}
                    </Box>
                  </TableCell>
                )
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => {
              return (
                <TableOptimizedRow
                  store={store}
                  index={i}
                  columns={columns}
                  row={row}
                  click={onRowClick}
                  hideFirstRow={true}
                  key={i}
                />
              )
            })}
          </TableBody>
        </Table>
        {(!operatorsStore.total || !operatorsStore.isLoaded) && (
          <NoDataFound
            length={data?.length}
            isLoaded={operatorsStore?.isLoaded}
          />
        )}
        {withScrollButtons && !!operatorsStore?.collection?.length && (
          <TableScrollButtons rowsLength={operatorsStore?.collection?.length} />
        )}
      </TableActionsBlock>
    </TableContainer>
  )
}

export default observer(RequestsNotesTableOptimized)
